// select the correct language here
import language from "./../../src/common/i18n/en_uk.json";

const dictionary = language;
// if needed change some strings here or add some

dictionary.Archive = "Editions";
dictionary.Promospot = "Magazines and Supplements";
dictionary.settings = "Settings";
dictionary.editor = "Publisher";
dictionary.alsoRead = "Follow the link below";
dictionary.Extra = "Advertisement";
dictionary.LogIn = "Sign in";
dictionary.login = "Sign in";
dictionary.LogInWith = "Signed in with:";
dictionary.accountLoggedOut = "Not signed in";
dictionary.accountLoggedIn = "Logged in";
dictionary.accountLoggedInInfo = "You are currently signed in.";
dictionary.accountLoggedWithInfo = "You are currently  signed in with";
dictionary.logout = "Sign out";
dictionary.disclaimer = "Privacy policy";
dictionary.PaperVersion = "Print version";
dictionary.Paper = "Print";
dictionary.Username = "Email";
dictionary.extras = "Specials";

dictionary.E1 = "Cannot connect to server. Try again later.";
dictionary.E2 = "Cannot connect to server. Try again later.";
dictionary.E3 = "Cannot connect to server. Try again later.";
dictionary.E4 = "Cannot connect to server. Try again later.";
dictionary.E5 = "Active subscription not found. Click on SUBSCRIBE.";
dictionary.E6 = "Active subscription not found. Click on SUBSCRIBE.";
dictionary.E7 =
  "Invalid credentials. Check your email/password and try again. ";
dictionary.E8 = "Information cannot be retrieved from server.";
dictionary.E9 = "Information cannot be retrieved from server.";
dictionary.E10 = "Information cannot be retrieved from server. ";
dictionary.E12 =
  "You have reached the maximum number of downloads with your subscription.";
dictionary.E12 = "Information cannot be retrieved from server.";
dictionary.E13 = "Information cannot be retrieved from server.";
dictionary.E14 =
  "There has been an error when verifying your credentials. Try again or contact our customer service.";
dictionary.E15 =
  "There has been an error when verifying your credentials. Try again or contact our customer service.";
dictionary.E16 =
  "There has been an error when verifying your credentials. Try again or contact our customer service.";
dictionary.E17 =
  "Invalid credentials. Check your email/password and try again.";
dictionary.E18 =
  "An error has occurred when downloading your newspaper. Please try again or contact customer service.";
dictionary.E20 =
  "Invalid credentials. Check your email/password and try again.";
dictionary.E21 = "Subscription has expired.";
dictionary.E24 = "Access error. Please contact Customer Service.";
dictionary.E25 =
  "Maximum number of concurrent sessions reached for the subscription.";
dictionary.E26 =
  "Invalid credentials. Check your email/password and try again.";

export default dictionary;



// WEBPACK FOOTER //
// ./clients/ALO-OPC/dictionary.js